import React from 'react'
import {CopyText, DataDisplay} from '@therms/atalaya'
import {RegionName, RPCDocs, useCurrentOrganization, useCurrentUser, UserGroupTags,} from '@therms/react-modules'
import {useCurrentUserAnPCheck} from '@src/modules/Users/shared/hooks/useCurrentUserAnPCheck.ts'

interface UserInfoProps {
  user: RPCDocs.Users.GetUserProfile.v1.User
}

function UserInfo({user}: UserInfoProps) {
  const currentUser = useCurrentUser()
  const {
    displayName,
    email,
    idNumber,
    phone,
    primaryRegionId,
    title,
    userGroupIds,
  } = user

  const canViewUserContactInfo = useCurrentUserAnPCheck(
    ({anp}) =>
      anp.role.ops.access.viewUserContactInfo || currentUser.id === user.id,
  )

  const {modules} = useCurrentOrganization()

  return (
    <>
      <DataDisplay>
        <DataDisplay.Item label="Name">{displayName}</DataDisplay.Item>

        {!!title && <DataDisplay.Item label="Title">{title}</DataDisplay.Item>}

        {!!idNumber && (
          <DataDisplay.Item label="ID / Badge">{idNumber}</DataDisplay.Item>
        )}

        {canViewUserContactInfo && (
          <DataDisplay.Item label="Email">
            <CopyText value={email}>
              <a
                href={`mailto:${email}`}
                target="blank"
                className="text-color-info underline"
              >
                {email}
              </a>
            </CopyText>
          </DataDisplay.Item>
        )}

        {canViewUserContactInfo && (
          <DataDisplay.Item label="Phone">{phone}</DataDisplay.Item>
        )}

        {Array.isArray(userGroupIds) && !!userGroupIds.length && (
          <DataDisplay.Item label="User Groups">
            <UserGroupTags userGroupIds={userGroupIds} />
          </DataDisplay.Item>
        )}

        {!!primaryRegionId && modules.regions && (
          <DataDisplay.Item label="Primary Region">
            <RegionName regionId={primaryRegionId} />
          </DataDisplay.Item>
        )}
      </DataDisplay>
    </>
  )
}

export {UserInfo}
